import { InternalAccessTab } from 'src/constants/internal-access/internalAccessTabs'

/** A tab is only shown with its view permission, so a requested hidden tab falls back. */
export const resolveInternalAccessTab = (
  requested: string | null,
  canViewUsers: boolean,
  canViewRoles: boolean,
): InternalAccessTab | null => {
  if (requested === InternalAccessTab.Roles && canViewRoles) {
    return InternalAccessTab.Roles
  }

  if (canViewUsers) {
    return InternalAccessTab.Users
  }

  if (canViewRoles) {
    return InternalAccessTab.Roles
  }

  return null
}
